import HttpMethodType from "HttpMethodType";
import SubSystemType from "SubSystemType";
import BaseServiceRequest from "BaseServiceRequest";

class AITextFeedbackRequest extends BaseServiceRequest {
  constructor(data) {
    super();
    super.addRequestUri("feedback");
    const reqData = {};
    reqData.ai_type_id = data.newsType;
    reqData.start_date = data.startDate;
    reqData.end_date = data.endDate;
    reqData.trend = data.trend;
    reqData.OSID = data.OSID;
    reqData.periodicity = data.periodicity;
    reqData.reactions = data.reactions;
    reqData.fiscal_year = data.fiscal_year;
    reqData.fiscal_quarter = data.fiscal_quarter;
    reqData.financial_metric = data.financial_metric;
    reqData.trackprice_date = data.trackprice_date;
    reqData.event_name = data.event_name;
    reqData.event_type = data.event_type;
    reqData.sentiment = data.sentiment;
    super.setContent(JSON.stringify(reqData));
  }

  getMethod() {
    return HttpMethodType.POST;
  }

  getSubSystem() {
    return SubSystemType.GRAPH;
  }
}

export default AITextFeedbackRequest;
